import { render } from "./game_runner.vue?vue&type=template&id=3ee232ce"
import script from "./game_runner.vue?vue&type=script&lang=js"
export * from "./game_runner.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__